import { useCurrentMediaStore } from '@stores/useCurrentMediaStore'

export const useCurrentMedia = () => {
  const currentMedia = useCurrentMediaStore((state) => state.currentMedia)
  const setCurrentMedia = useCurrentMediaStore((state) => state.setCurrentMedia)
  const resetCurrentMedia = useCurrentMediaStore(
    (state) => state.resetCurrentMedia,
  )

  return { currentMedia, setCurrentMedia, resetCurrentMedia }
}
